<script setup lang="ts">
import { computed } from "vue";

import type { Counter } from "@/model/Counter";
import { useClientSettingsStore } from "@/store/clientSettings";
import { useStatisticsStore } from "@/store/statistics";

import AreaGraph from "./internal/AreaGraph.vue";

const show = computed(() => useClientSettingsStore().showStats);
const stats = computed(() => useStatisticsStore().statistics);
const current = computed(() => useStatisticsStore().current);

function counter(c: Counter) {
  return c.ok + "/" + c.fail;
}
</script>

<template>
  <div v-if="show > 0" id="statistics" data-no-screenshot>
    <div>
      <AreaGraph v-if="show > 1" :stats property="subscriptions" />
      <div data-t>Sub {{ current.subscriptions }}</div>
    </div>
    <div>
      <AreaGraph v-if="show > 1" :stats property="calls" />
      <div data-t>Call {{ counter(current.calls) }}</div>
    </div>
    <div>
      <AreaGraph v-if="show > 1" :stats property="sends" />
      <div data-t>Send {{ counter(current.sends) }}</div>
    </div>
    <div>
      <AreaGraph v-if="show > 1" :stats property="publishes" />
      <div data-t>Pub {{ counter(current.publishes) }}</div>
    </div>
    <div>
      <AreaGraph v-if="show > 1" :stats property="receives" />
      <div data-t>Recv {{ counter(current.receives) }}</div>
    </div>
    <div>
      <AreaGraph v-if="show > 1" :stats property="reconnects" diff />
      <div data-t>Reconnects {{ current.reconnects }}</div>
    </div>
    <div>
      <AreaGraph v-if="show > 1" :stats property="storesLen" />
      <div data-t>Stores Len {{ current.storesLen }}</div>
    </div>
  </div>
</template>

<style lang="scss">
@use "@/styles/variables";
@use "@/styles/z-index";

#statistics {
  position: fixed;
  bottom: 1em;
  left: 70px;
  z-index: z-index.$statistics;
  font-size: 8px;
  filter: opacity(40%);
  pointer-events: none;

  div {
    display: inline-block;
    width: 10em;
    margin-right: 1em;
  }

  .graph {
    height: 7em;
  }
}
</style>
